import { Status} from "./models/status.model";
import { Injectable } from "@angular/core";

@Injectable()
export class StatusService{
  constructor(){
    
  }
  getListStatus():Status[]{
    let statusList:Status[]=[];
    statusList.push( new Status(1, 'Hoạt động'));
    statusList.push( new Status(0, 'Không hoạt động'));
    return statusList;
  }
}